<template lang="pug">
#service-sidebar.sidebar
  service-sidebar-block(
    v-if="config.channels && channels.length > 1"
    heading="Services"
    index="channels"
    :filters="channels"
  )
  service-sidebar-block(
    v-if="config.speakers && speakers.length > 1"
    heading="Speakers"
    index="speakers"
    :filters="speakers"
  )
  service-sidebar-block(
    v-if="config.years && years.length > 1"
    heading="Years"
    index="years"
    :filters="years"
  )
  service-sidebar-block(
    v-if="config.tags && tags.length > 1"
    heading="Topics"
    key="tags"
    :filters="tags"
  )
</template>

<script>
import { mapGetters } from 'vuex';
import ServiceSidebarBlock from '@/components/episodes/ServiceSidebarBlock.vue';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'services-sidebar',
  components: {
    ServiceSidebarBlock,
  },
  computed: {
    ...mapGetters({
      channels: getterTypes.GET_EPISODES_AGGREGATIONS_BY_CHANNEL,
      filters: getterTypes.GET_SERVICES_FILTERS,
      speakers: getterTypes.GET_EPISODES_AGGREGATIONS_BY_SPEAKER,
      years: getterTypes.GET_EPISODES_AGGREGATIONS_BY_YEAR,
      tags: getterTypes.GET_EPISODES_AGGREGATIONS_BY_TAGS,
    }),
  },
  props: {
    config: {
      type: Object,
      default() {
        return {
          channels: true,
          speakers: true,
          years: true,
          tags: true,
        };
      },
    },
  },
};
</script>

<style lang="scss">
#service-sidebar {

}
</style>

<style theme="cwo" lang="scss">
#service-sidebar {
  background-color: $dark;
}
</style>

<style theme="ffc" lang="scss">
#service-sidebar {
  background-color: $white;
  border-right: 1px solid #eaeaea;
}
</style>
